import { render } from "./profile-insurence.vue?vue&type=template&id=38f68412"
import script from "./profile-insurence.vue?vue&type=script&lang=js"
export * from "./profile-insurence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__